import config from "src/config";
import http, { postWithBasicHeader } from "../services/apiServices";
import { ILogin } from "src/redux/interfaces/IProfile";


export const cdLoginApi = async (data: ILogin) => {
  return await postWithBasicHeader(config.CivilDefense.signIn, data);
};

export const getBMCTemplatesAPI = async (bmcId: any) => {
  return await http.get(config.CivilDefense.getBMCTemplates + bmcId);
};


export const getBMCListAPI = async () => {
  return await http.get(config.CivilDefense.getBMCs);
};


export const sendRequestToBMCAPI = async (data: any) => {
  return await http.post(config.CivilDefense.sendRequestToBMC, data);
};